import { connect } from "react-redux";
import { useEffect, useRef, useState } from "react";
import logo_selah from "assets/img/selah.png";
import google_play from "assets/img/google_play.png";
import app_store from "assets/img/app_store.svg";

function Footer({ scrollRef }) {
  const [isVisible, setIsVisible] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    const ref = footerRef.current;
    return () => {
      if (ref) {
        observer.unobserve(ref);
      }
    };
  }, []);

  const handleLogoClick = () => {
    if (scrollRef?.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleComingSoon = () => {
    alert("La aplicación estará disponible próximamente.");
  };

  return (
    <footer
      ref={footerRef}
      className={`w-full fixed bg-gray-50 text-gray-600 relative transition-opacity duration-100 ease-in-out ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto py-4 sm:py-5 lg:py-6 px-4 flex flex-col items-center justify-center relative">
        {/* Left Text + Email */}
        <div
          className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-1
          absolute
          left-1/2
          transform
          -translate-x-1/2
          top-[-2rem]
          lg:top-1/2
          lg:left-4
          lg:translate-x-0
          lg:-translate-y-1/2"
        >
          <br />
          <br />
          <p className="text-md sm:text-base font-bembo text-gray-600">
            Esta página es dedicada a Dios.
          </p>
          <p className="text-md sm:text-base font-bembo text-gray-600">
            Correo a:{" "}
            <a
              href="mailto:contacto@selah.mx"
              className="underline hover:text-gray-800 break-all"
            >
              contacto@selah.mx
            </a>
          </p>
        </div>

        <div className="h-6" />
        <br />
        <br />
        {/* Logo + Scroll to Top */}
        <div className="flex flex-col items-center space-y-2">
          <span className="text-sm sm:text-base lg:text-lg font-semibold font-bembo text-gray-800">
            Presiona logo para ir arriba
          </span>
          <button
            type="button"
            onClick={handleLogoClick}
            aria-label="Presiona para volver al inicio"
            className="cursor-pointer transition-transform duration-300 ease-in-out hover:scale-105"
          >
            <img
              src={logo_selah}
              alt="Logo de Selah"
              className="h-12 sm:h-14 lg:h-16 w-auto"
            />
          </button>
        </div>

        <div className="h-2" />

        {/* App Store Badges */}
        <br />
        <div className="lg:absolute right-4 top-1/2 transform -translate-y-1/2 flex flex-col items-center space-y-3 mt-4 lg:mt-0">
          <h3 className="text-sm sm:text-base lg:text-lg font-semibold font-bembo text-gray-800 text-center lg:text-right">
            Descarga aplicación Selah
          </h3>
          <div className="flex flex-row justify-center space-x-6">
            <button
              type="button"
              onClick={handleComingSoon}
              aria-label="Google Play próximamente"
              title="Próximamente en Google Play"
              className="transition-transform transform duration-300 ease-in-out hover:scale-105 hover:drop-shadow-lg hover:brightness-125"
            >
              <img src={google_play} alt="Google Play Store" className="h-10" />
            </button>
            <button
              type="button"
              onClick={handleComingSoon}
              aria-label="App Store próximamente"
              title="Próximamente en App Store"
              className="transition-transform transform duration-300 ease-in-out hover:scale-105 hover:drop-shadow-lg hover:brightness-125"
            >
              <img src={app_store} alt="App Store" className="h-10" />
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="border-t border-gray-200 mt-4">
        <p className="text-sm sm:text-base lg:text-lg font-bembo text-gray-400 text-center py-2">
          Copyright &copy; 2025 multusoftware, Inc. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(Footer);
